import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";

@Component({
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.css']
})
export class ProgressbarComponent implements ICellRendererAngularComp {
  public params: any;
  
      agInit(params: any): void {
          this.params = params;
          setTimeout(()=>{
            document.getElementById("file-"+params.rowIndex).style.width = params.data.progress + "%";
          });
      }
  
      refresh(): boolean {
          return false;
      }
}



// WEBPACK FOOTER //
// ./src/app/progressbar/progressbar.component.ts